import React from "react";
import * as aor from "react-admin";
import myRestClient from "../common/restClient";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { getLoggedUser } from "../common/authClient";
import Card from "@material-ui/core/Card";
import { Button } from "@material-ui/core";
import history from "../common/history";

const styles = theme => ({
    root: {
        width: "100%",
        marginTop: theme.spacing.unit * 3,
        overflowX: "auto"
    },
    card: {
        position: "relative",
        padding: 20
    },
    dialog: {
        display: "flex",
        flexDirection: "column",
        margin: "auto",
        width: "fit-content"
    },
    table: {
        border: "none"
    }
});

class Profile extends React.Component {
    state = { mappings: [], user_id: null, user: null };

    handleCancel = () => {
        this.setState({ show_dialog: false });
    };

    handleClick = () => {
        history.push(`/reset_password`);
    };

    componentDidMount() {
        getLoggedUser().then(logged_user => {
            if (logged_user) {
                this.setState({
                    user_id: logged_user.id,
                    user: logged_user
                });
                const params = {
                    user_id: this.state.user_id
                };
                myRestClient("GET_ROLE", "role-mappings", params).then(
                    result => {
                        this.setState({ mappings: result.data });
                    },
                    error => {
                        return error;
                    }
                );
            }
        });
    }

    renderCompaniesLabel() {
        return <span>Aziende Collegate</span>;
    }
    renderProfileCompanies() {
        const { classes } = this.props;
        return (
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        <TableCell>Ruolo</TableCell>
                        <TableCell align="right">Ragione sociale</TableCell>
                        <TableCell align="right">Partita Iva</TableCell>
                        <TableCell align="right">Codice Rivenditore</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state.mappings.map(row => (
                        <TableRow key={row.id}>
                            <TableCell component="th" scope="row">
                                {row.role}
                            </TableCell>
                            <TableCell align="right">{row.name}</TableCell>
                            <TableCell align="right">{row.vatin}</TableCell>
                            <TableCell align="right">
                                {row.seller_code}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    renderProfileContent() {
        const user = this.state.user;

        return (
            <div>
                <table style={{ borderSpacing: 10, marginTop: 10 }}>
                    <tbody>
                        <tr>
                            <td>Nome utente:</td>
                            <td>
                                <b>{user ? user.username : ""}</b>
                            </td>
                        </tr>
                        <tr>
                            <td>Nome:</td>
                            <td>
                                <b>{user ? user.name : ""}</b>
                            </td>
                        </tr>
                        <tr>
                            <td>Cognome:</td>
                            <td>
                                <b>{user ? user.surname : ""}</b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        const { classes } = this.props;
        return (
            <div>
                <aor.Title title="resources.profile.views.list.title" />
                <Card className={classes.card}>
                    <div>{this.renderProfileContent()}</div>

                    <Button
                        color="primary"
                        variant="contained"
                        onClick={this.handleClick}
                    >
                        Reimpostare la password
                    </Button>
                    <div style={{ marginLeft: 10, marginTop: 20 }}>
                        {this.renderCompaniesLabel()}
                    </div>
                    <div style={{ margin: 10 }}>
                        {this.renderProfileCompanies()}
                    </div>
                </Card>
            </div>
        );
    }
}

export default withStyles(styles)(Profile);



// WEBPACK FOOTER //
// ./src/components/Profile.js